<template>
    <button
        class="rounded-32 flex flex-none items-center justify-center trans-ease"
        :class="buttonClass"
        type="button"
        @click="handleClick"
        :disabled="disabled"
    >
        <svg-icon
            :type="icon"
            :class="svg24 ? 'max-w-24 max-h-24' : svgBig ? (smaller ? 'max-w-24 max-h-24' : 'max-w-32 max-h-32') : 'max-w-16 max-h-16'"
        />
    </button>
</template>

<script>
import SvgIcon from './SvgIcon.vue';

export default {
    components: {
        'svg-icon': SvgIcon,
    },
    props: {
        icon: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        small: Boolean,
        smaller: Boolean,
        outline: Boolean,
        light: Boolean,
        dark: Boolean,
        active: Boolean,
        svgBig: Boolean,
        svg24: Boolean,
        white: Boolean,
        customClass: String
    },
    computed: {
      buttonClass() {
          let classes = [];

          if(this.customClass) {
              return [this.customClass];
          }

          classes = [
              this.small ? 'w-16 h-16' : (this.smaller ? 'w-32 h-32' : 'w-40 h-40'),
              this.outline ? 'border ' + (this.light && !this.active ? 'border-primary-80' : 'border-white') : '',
          ];

          if(this.disabled) {
              classes.push('bg-primary-20 text-white cursor-not-allowed');
          } else {
              classes.push(this.active ?
                  'bg-secondary text-white is-active' :
                  (this.light ?
                          'bg-primary-20 text-primary-80' :
                          (this.dark ?
                                  'bg-transparent text-primary-5  hover:text-black' :
                                  (this.white ?
                                      'bg-white border border-primary-20' :
                                      'bg-primary text-white')
                          )
                  )
              );
          }

          return classes;
      }
    },
    methods: {
        handleClick() {
            this.$emit('click');
        }
    },
}
</script>

<style scoped>
button {
    &:not(.is-active):hover,
    &:not(.cursor-not-allowed):hover{
        transform: scale(1.1);
    }
}
</style>
